import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import TheHeader from "./components/TheHeader";
import TheFooter from "./components/TheFooter";
import titleMixin from "./mixins/titleMixin";
import infiniteScroll from "vue-infinite-scroll";
import VueTheMask from "vue-the-mask";
import Vuelidate from "vuelidate";

Vue.config.productionTip = false;

Vue.component("TheHeader", TheHeader);
Vue.component("TheFooter", TheFooter);

Vue.mixin(titleMixin);
Vue.use(infiniteScroll);
Vue.use(VueTheMask);
Vue.use(Vuelidate);

console.log('test. . .');

Vue.prototype.$http = axios.create({
  baseURL: "https://api-vendas-todos.azurewebsites.net/api/",
});

Vue.prototype.$api = axios.create({
  baseURL:
    "https://www.cartaodetodossaopaulofc.com.br/api/index.php/wp-json/acf/v3/",
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
